import * as sup from 'superstruct';

import {
  createIdentifierStruct,
  createResourceStruct,
} from '@/modules/api/utils/jsonApiStructs';
import {
  NegotiationTermRole,
  NegotiationType,
} from '@/modules/negotiation/types/negotiationTypes';
import { dateTime } from '@/utils/structs/structs';

export const demoNegotiationResourceStruct = createResourceStruct({
  identifier: createIdentifierStruct('demo_negotiation'),
  attributes: sup.object({
    title: sup.string(),
    estimatedDiscount: sup.number(),
    estimatedInflation: sup.number(),
    suppliersCount: sup.number(),
    totalSpend: sup.number(),
    termRoles: sup.array(sup.enums(Object.values(NegotiationTermRole))),
    negotiationTypes: sup.array(sup.enums(Object.values(NegotiationType))),
    potentialSavings: sup.number(),
    potentialCostAvoidance: sup.number(),
    periodIndex: sup.nullable(sup.number()),
    periodOrder: sup.number(),
    createdAt: dateTime,
  }),
});
